import common from "./common";
import errors from "./errors";
import nav from "./nav";
import auth from "./auth";
import validation from "./validation";
import tickets from "./tickets";
import handshake from "./handshake";
import constants from "./constants";
import dashboard from "./dashboard";
import activities from "./activities";
import bookings from "./bookings";
import settings from "./settings";
import support from "./support";
import sellerFaq from "./sellerFaq";
import admin from "./admin";
import devices from "./devices";
import readers from "./readers";
import houses from "./houses";
import wallet from "./wallet";
import points from "./points";
import adminUsers from "./adminUsers";
import adminActivities from "./adminActivities";
import adminStructures from "./adminStructures";
import sellers from "./sellers";
import hosts from "./hosts";
import salesAgent from "./salesAgent";
import handshakePages from "./handshakePages";
import kiosk from "./kiosk";
import components from "./components";
import payments from "./payments";
import adminNotifications from "./adminNotifications";
import adminCarousel from "./adminCarousel";
import adminProtocols from "./adminProtocols";
import adminAgentTranscripts from "./adminAgentTranscripts";
import adminDeviceStats from "./adminDeviceStats";

export default {
  common,
  errors,
  nav,
  auth,
  validation,
  tickets,
  handshake,
  constants,
  dashboard,
  activities,
  bookings,
  settings,
  support,
  sellerFaq,
  admin,
  devices,
  readers,
  houses,
  wallet,
  points,
  adminUsers,
  adminActivities,
  adminStructures,
  sellers,
  hosts,
  salesAgent,
  handshakePages,
  kiosk,
  components,
  payments,
  adminNotifications,
  adminCarousel,
  adminProtocols,
  adminAgentTranscripts,
  adminDeviceStats,
};
